import window from "inputmask/lib/global/window";

const $ = require("jquery");
require("jquery.cookie");

export const initFavorite = function () {
  $(document).on("click", ".favorite-block", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const block = $(this);
    const campId = block.data("camp-id");
    const isFavorited = block.data("favorited");
    const isInstant = window.camp.is_can_instant_booking;

    if (isFavorited) {
      removeFromFavorites(campId, block);
    } else {
      addToFavorites(campId, block);
    }

    changeMapMarker(campId, isFavorited, isInstant);
  });

  $(document).ready(function () {
    if (
      window.location.pathname === `${window.website_prefix}/account/favorites`
    ) {
      const campIds = $("#favorites").data("camp-ids");
      const currentSearchParams = new URLSearchParams(window.location.search);
      const currentCampIds = currentSearchParams.get("camp_ids");

      if (campIds) {
        document.cookie =
          "shared_camp_ids=" +
          encodeURIComponent(JSON.stringify(campIds)) +
          ";path=/";

        if (currentCampIds !== campIds) {
          updateUrl({ campIds: campIds });
        }
      } else if (!currentCampIds && campIds) {
        const sharedCampIds = getCookie("shared_camp_ids=");
        if (sharedCampIds) {
          updateUrl({ campIds: sharedCampIds });
        }
      }
    }
  });
};

export function changeMapMarker(campId, isFavorite, isInstant) {
  const placemarkContainer = $(
    '.placemark_layout_container[data-camp-id="' + campId + '"]',
  );
  const placemarkIcon = placemarkContainer.find("#placemark-icon");
  const selected = placemarkContainer.hasClass("selected");
  let iconClass = "";

  if (isFavorite) {
    placemarkIcon.removeClass();
    if (isInstant) {
      const baseClass = selected ? "icon-flash_white" : "icon-instant-fill";
      iconClass = `icon ${baseClass} ${baseClass}-dims`;
      placemarkIcon.addClass(iconClass);
    }
  } else {
    iconClass = selected ? "unfavorite-icon selected" : "unfavorite-icon";
    placemarkIcon.removeClass().addClass(iconClass);
  }
}

export function changeFavoriteBlock(block = null) {
  if (!block) block = $(".favorite-block");
  block.attr("title", "Удалить из избранного");
  block
    .find(".favorite")
    .removeClass("favorite-icon")
    .addClass("unfavorite-icon");
  block.find(".favorite-text").text("В избранном");
  block.data("favorited", true);
}

export function changeUnfavoriteBlock(block = null) {
  if (!block) block = $(".favorite-block");
  block.attr("title", "");
  block
    .find(".favorite")
    .removeClass("unfavorite-icon")
    .addClass("favorite-icon");
  block.find(".favorite-text").text("В избранное");
  block.data("favorited", false);
}

export function addToFavorites(campId, block) {
  changeFavoriteBlock(block);

  if (window.favorite_camp_ids) {
    window.favorite_camp_ids.push(campId);
  }

  $.ajax({
    url: `/favorite/${campId}`,
    method: "POST",
    headers: {
      "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
    },
    success: function (result) {
      if (!result) {
        addToCookie(campId);
      }

      if (
        window.location.pathname ===
        `${window.website_prefix}/account/favorites`
      ) {
        updateUrl({ campId: campId });
      }

      const favoriteCount = getFavoritesCount(result);
      $(".favorite-count").removeClass("hidden").show().text(favoriteCount);
    },
  });
}

export function removeFromFavorites(campId, block) {
  changeUnfavoriteBlock(block);

  if (window.favorite_camp_ids) {
    window.favorite_camp_ids = window.favorite_camp_ids.filter(
      (id) => id !== campId,
    );
  }

  $.ajax({
    url: `/unfavorite/${campId}`,
    method: "DELETE",
    headers: {
      "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
    },
    success: function (result) {
      if (!result) {
        removeFromCookie(campId);
      }

      if (
        window.location.pathname ===
        `${window.website_prefix}/account/favorites`
      ) {
        updateUrl({ campId: campId, addCamp: false });
      }

      const favoriteCount = getFavoritesCount(result);
      if (favoriteCount > 0) {
        $(".favorite-count").removeClass("hidden").show().text(favoriteCount);
      } else {
        $(".favorite-count").addClass("hidden");
        document.cookie = "shared_camp_ids=;path=/";
      }
    },
  });
}

function addToCookie(campId) {
  const favoriteCamps = getCookie("favorite_camp_ids=");
  if (!favoriteCamps.includes(campId)) {
    favoriteCamps.push(campId);
    document.cookie =
      "favorite_camp_ids=" +
      encodeURIComponent(JSON.stringify(favoriteCamps)) +
      ";path=/";
  }
}

function removeFromCookie(campId) {
  let favoriteCamps = getCookie("favorite_camp_ids=");
  if (favoriteCamps.includes(campId)) {
    favoriteCamps = favoriteCamps.filter((id) => id !== campId);
    document.cookie =
      "favorite_camp_ids=" +
      encodeURIComponent(JSON.stringify(favoriteCamps)) +
      ";path=/";
  }
}

function getFavoritesCount(result) {
  let favoriteCount;
  if (result) {
    favoriteCount = result.favorites_count;
  } else {
    const favoriteCamps = getCookie("favorite_camp_ids=");
    if (favoriteCamps) {
      favoriteCount = favoriteCamps.length;
    }
  }

  return favoriteCount;
}

function getCookie(name) {
  const decodedCookie = decodeURIComponent(document.cookie);
  const parts = decodedCookie.split(";");
  for (let i = 0; i < parts.length; i++) {
    let part = parts[i].trim();
    if (part.indexOf(name) === 0) {
      return JSON.parse(part.substring(name.length, part.length));
    }
  }
  return [];
}

export function setFavorites(campId = null, block = null) {
  let campIdValue, $favoriteBlock;
  if (campId && block) {
    campIdValue = campId;
    $favoriteBlock = block.filter(function () {
      return $(this).data("camp-id") === campIdValue;
    });
  } else {
    $favoriteBlock = $(".favorite-block");
    campIdValue = $favoriteBlock.data("camp-id");
  }

  if (campIdValue) {
    $.ajax({
      url: "/favorites/" + campIdValue,
      method: "GET",
      success: function(data) {
        if (data.is_favorite) {
          changeFavoriteBlock($favoriteBlock);
        } else {
          changeUnfavoriteBlock($favoriteBlock);
        }

        $favoriteBlock.data("favorited", data.is_favorite);
      },
    });
  }
}

function updateUrl({ campIds = null, campId = null, addCamp = true } = {}) {
  const currentSearchParams = new URLSearchParams(window.location.search);
  const currentCampIds = currentSearchParams.get("camp_ids") || "";
  let searchCampIds = campIds || currentCampIds;

  if (campId) {
    campId = campId.toString();
    const idsArray = searchCampIds.split(",").filter((id) => id);

    if (addCamp) {
      if (!idsArray.includes(campId)) {
        idsArray.push(campId);
      }
    } else {
      const index = idsArray.indexOf(campId);
      if (index > -1) {
        idsArray.splice(index, 1);
      }
    }

    searchCampIds = idsArray.join(",");
  }

  const searchData = JSON.parse($.cookie("search_data"));
  const url = new URL(window.location);
  const urlParams = new URLSearchParams();

  urlParams.set("camp_ids", searchCampIds);
  if (searchData.date_start) urlParams.set("date_start", searchData.date_start);
  if (searchData.date_end) urlParams.set("date_end", searchData.date_end);
  urlParams.set("count_guests", searchData.count_guests);
  urlParams.set("children_ages", searchData.children_ages);

  url.search = urlParams.toString();
  window.history.replaceState({}, "", url);
}

export function initializeFavorites(camps) {
  const initialFavorites = [];
  for (const camp of camps) {
    if (camp.is_favorite) initialFavorites.push(camp.id);
  }
  return initialFavorites;
}

export async function loadFavoriteCamps() {
  const response = await fetch(`/all_favorites`);
  const result = await response.json();
  return result.favorite_camp_ids;
}
